import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../../../assets/widget-shared.scss';

export const templateMspInProductTrialsOverlayWindow = document.createElement('template');

templateMspInProductTrialsOverlayWindow.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="msp-in-product-trials-overlay-container">
    <img id="msp-in-product-trials-overlay-window-image"/>

    <gz-title id="msp-in-product-trials-overlay-window-title"></gz-title>
    <gz-text id="msp-in-product-trials-overlay-window-text"></gz-text>

    <gz-button id="msp-in-product-trials-overlay-window-button1"></gz-button>
    <gz-button id="msp-in-product-trials-overlay-window-button2"></gz-button>
    <gz-button id="msp-in-product-trials-overlay-window-button3"></gz-button>

    <gz-form-field id="msp-in-product-trials-overlay-window-checkbox" class="hidden">
          <gz-checkbox gz-form-input color="overlay"></gz-checkbox>
    </gz-form-field>
  </div>
`;
